module.exports = __webpack_public_path__ + "static/sign-up-form-1-5-3335023301ce5bf74e24c8d215de5c8c.png";